import React from 'react';
import classNames from 'classnames';

import { Link } from 'react-router-dom';

import styles from './styles.module.scss';

export const LinkButton: React.FC<sharedComponents.LinkButton> = ({
  text,
  link = '#',
  secondary,
  target = '_blank',
  banner,
  className = '',
  analytics,
  action,
  isInternal,
}) => {
  const linkClassNames = classNames(styles.btn, {
    [styles.secondary]: secondary,
    [styles.banner]: banner,
    [className]: className,
  });

  if (action) {
    return (
      <button
        type="button"
        className={linkClassNames}
        data-analytics-link={analytics}
        onClick={action}
      >
        {text}
      </button>
    );
  }

  return isInternal ? (
    <Link
      className={linkClassNames}
      to={link}
      data-analytics-link={analytics}
      onClick={action}
    >
      {text}
    </Link>
  ) : (
    <a
      className={linkClassNames}
      href={link}
      data-analytics-link={analytics}
      target={target}
      rel="noopener noreferrer"
    >
      {text}
    </a>
  );
};
